/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowThread200ResponseData } from './ShowThread200ResponseData';
import {
    ShowThread200ResponseDataFromJSON,
    ShowThread200ResponseDataFromJSONTyped,
    ShowThread200ResponseDataToJSON,
    ShowThread200ResponseDataToJSONTyped,
} from './ShowThread200ResponseData';

/**
 * 
 * @export
 * @interface ShowThread200Response
 */
export interface ShowThread200Response {
    /**
     * 
     * @type {ShowThread200ResponseData}
     * @memberof ShowThread200Response
     */
    data?: ShowThread200ResponseData;
}

/**
 * Check if a given object implements the ShowThread200Response interface.
 */
export function instanceOfShowThread200Response(value: object): value is ShowThread200Response {
    return true;
}

export function ShowThread200ResponseFromJSON(json: any): ShowThread200Response {
    return ShowThread200ResponseFromJSONTyped(json, false);
}

export function ShowThread200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowThread200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ShowThread200ResponseDataFromJSON(json['data']),
    };
}

export function ShowThread200ResponseToJSON(json: any): ShowThread200Response {
    return ShowThread200ResponseToJSONTyped(json, false);
}

export function ShowThread200ResponseToJSONTyped(value?: ShowThread200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShowThread200ResponseDataToJSON(value['data']),
    };
}

